import { render, staticRenderFns } from "./monthly.vue?vue&type=template&id=2349ab3a&scoped=true&"
import script from "./monthly.vue?vue&type=script&lang=js&"
export * from "./monthly.vue?vue&type=script&lang=js&"
import style0 from "./monthly.vue?vue&type=style&index=0&id=2349ab3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349ab3a",
  null
  
)

export default component.exports